<template>
	<div class="count-view">
        <chillNavbar path_title="current_visit_and_craft" :current_visit="singleVisit.store_name_app" :craft="singleVisit.craft" betreiber="REWE Nord" />
        <h3>{{ singleVisit.store_name_app }}</h3>
        <h3>{{ trans($route.params.craft + "_counting_view_text") }}</h3>
        <span>{{trans('devices_to_inspect_during_visit')}}</span>
        <div class="button-box" style="width: 300px" v-if="subcomponents.length > 0" >
                <button class="button-box-element" style="width: 300px" @click="setCountBasedOnsubcomponents()">{{ trans('set_count_based_on_prev') }}</button>
            </div>
        
        <div class="list-of-components">
            <div class="component-row" v-for="type in listOfTypes" v-bind:key="type">
                <span class="component-row-text">{{trans(type)}}</span>
                <div class="divCountBox">
                    <chill-icon @click="countComponent(type, '-')" class="operator-sign dark new-tab-one-icon medium-icon" icon="zoom_out_circle"/>
                    <p class="countNumber"> {{ count[type] ? count[type] : 0 }} </p>
                    <chill-icon  @click="countComponent(type, '+')" class="operator-sign dark new-tab-one-icon medium-icon" icon="zoom_in_circle"/>
                </div>
            </div>
            <div class="button-box" >
                <button class="button-box-element" @click="count_done()">{{trans('count_done')}}</button>
                <span v-if="Object.values(count).length > 0"> {{trans("total_amount_counted")}}: {{Object.values(count).reduce((a, b) => a + b)}} </span>
            </div>
        </div>
	</div>
</template>

<script>
	export default {
		name: 'count',
		data() {
			return {
				count: {},
			}
		},
        watch: {
            singleVisit(){
                if(this.singleVisit.count_done){
                    this.count = this.singleVisit.count
                }
            }
        },
		methods: {
            setCountBasedOnsubcomponents(){
                this.count = {}
                if(this.subcomponents.length > 0){
                    // there are older items.
                    console.log(this.listOfTypes)
                    this.subcomponents.forEach(comp => {
                        console.log(comp.type)
                        if(this.count[comp.type]){
                            this.count[comp.type] ++
                        }else if(this.listOfTypes.includes(comp.type)){
                            this.count[comp.type] = 1
                        }
                    });
                }
            },
            countComponent(type, operator) {
                if(!this.count[type] || this.count[type] == 0)
                    this.count[type] = 0

                if(operator == '-' && this.count[type] == 0)
                    this.count[type] = 0
                else if(operator == '+') {
                    this.count[type] = this.count[type] + 1
                }
                else if(operator == '-') {
                    this.count[type] = this.count[type] - 1
                }
                this.$forceUpdate()
            },
			async count_done(){
				await this.updateVisit(this.$route.params.visit_id,{count: this.count, count_done:true})
				this.$router.push({ path: `/visit/${this.$route.params.market_id}/${this.$route.params.visit_id}` });
			}
		},
		beforeRouteLeave(to, form , next){
			this.clearMarketData();
			this.clearVisitData();
			next()
		},
        mounted(){
            this.startListOfTypes(this.$route.params.craft)
            this.startSingleVisitListener(this.$route.params.visit_id)
            this.startComponentListener(this.$route.params.market_id)
        }
	}
</script>

<style scoped lang="scss">
    .count-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        max-width: 900px;
        .list-of-components {
            display: flex;
            flex-direction: column;
            margin: 0px auto;
            margin-top: 12px;
            margin-bottom: 20px;
            height: calc(100vh - 280px);
            overflow: auto;
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            &::-webkit-scrollbar { 
                display: none;  /* Safari and Chrome */
            }
            .component-row {
                margin: 8px 0px;
                height: 56px;
                display: flex;
                justify-content: space-between;
                border-left: solid #1B608C 5px;
                background-color: #fff;
                .component-row-text {
                    margin: auto 0px auto 8px;
                    font-size: 14px;
                    font-weight: 300;
                }
                .divCountBox {
                    background-color: #fff;
                    align-items: center;
                    display: flex;
                    margin: 1px;
                    .countNumber {
                        width: 25px;
                        text-align: center;
                        border-bottom: solid #565760 1px;
                    }
                    .operator-sign {
                        font-size: 16px;
                        padding: 12px 6px;
                        width: 24px;
                        text-align: center;
                        &:hover {
                            cursor: pointer;
                        }
                    }
                }
            }
            .button-box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 18px;
                margin-bottom: 34px;
                .button-box-element {
                    width: 150px;
                    background-color: #1B608C;
                    color: #FFF;
                    height: 28px;
                    border-radius: 28px;
                    border: none;
                    margin-top: auto;
                    margin-bottom: auto;
                }
            }
        }
    }

    span {
        font-size: 14px;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }

</style>